// Broadcast-style short codes for college sports. Pro labels pass through unchanged.
const SHORT_CODES = {
  Football: "CFB",
  Basketball: "MBB",
  "Basketball (W)": "WBB",
  Baseball: "BSB",
  Softball: "SB",
};

// Compact labels coming straight from backend feed configs.
const FEED_CODES = {
  "NCAA FB": "CFB",
  "NCAA FB · FCS": "CFB · FCS",
  "NCAA MBB": "MBB",
  "NCAA WBB": "WBB",
};

export function sportShort(sportLabel) {
  if (!sportLabel) return "";
  if (FEED_CODES[sportLabel]) return FEED_CODES[sportLabel];
  if (!sportLabel.startsWith("College")) return sportLabel;
  return SHORT_CODES[sportLabel.replace("College ", "")] || sportLabel;
}
